import { IdReferenceDto, UserItemDto } from '@artemis-software/wr-api';

export function userToIdReference(user: UserItemDto | undefined): IdReferenceDto | undefined {
  if (!user) {
    return undefined;
  }
  return {
    value: user.id,
  };
}
